const SET_WORK_TYPE = "SET_CARE_TYPE";
const SET_ADDRESS = "SET_ADDRESS";
const SET_PHONE_NUMBER = "SET_PHONE_NUMBER";
const SET_SCHEDULE = "SET_SCHEDULE";

export const setWorkType = (workType) => ({
  type: SET_WORK_TYPE,
  payload: workType,
});
export const setAddress = (key, text) => ({
  type: SET_ADDRESS,
  payload: text,
  meta: key,
});
export const setPhoneNumber = (phoneNumber) => ({
  type: SET_PHONE_NUMBER,
  payload: phoneNumber,
});
export const setSchedule = (key, value) => ({
  type: SET_SCHEDULE,
  payload: value,
  meta: key,
});

const initialState = {
  address: {
    locationCode: "",
    roadCode: "",
    roadAddress: "",
    jibunAddress: "",
    sidoName: "",
    sigunguName: "",
    myundongName: "",
    liName: "",
    addressDetail: "",
  },
  phoneNumber: "",
  schedule: {
    startDate: "",
    endDate: "",
    visitTime: "",
    hour: 0,
  },
  workType: "",
};

export default function form(state = initialState, action) {
  switch (action.type) {
    case SET_ADDRESS:
      return {
        ...state,
        address: {
          ...state.address,
          [action.meta]: action.payload,
        },
      };
    case SET_PHONE_NUMBER:
      return {
        ...state,
        phoneNumber: action.payload,
      };
    case SET_SCHEDULE:
      return {
        ...state,
        schedule: {
          ...state.schedule,
          [action.meta]: action.payload,
        },
      };
    case SET_WORK_TYPE:
      return {
        ...state,
        workType: action.payload,
      };
    default:
      return state;
  }
}
